import {getRequest} from '@/Services/ApiService';
import APIURL from '@/api-url';
import type {LatestInsightPost} from '@/types/listing';

const PER_PAGE = 3;

// Only the fields the card renders — keeps the WP response and the serialized
// page data (__NEXT_DATA__) small instead of shipping full post payloads.
export const LATEST_INSIGHTS_FIELDS = 'id,slug,title,date,blog_image,excerpt,custom_updated_date';

/**
 * Server-side fetcher for the "Our Latest Insights" cards.
 *
 * Call from `getStaticProps`/`getServerSideProps` so the three posts land in the
 * initial HTML (crawlable, works with JS disabled). On the server `blogApiClient`
 * resolves to the WordPress base URL directly (see Services/HttpClient.ts), so this
 * uses the same `getRequest` as the client.
 *
 * Failures resolve to an empty array so a transient WordPress outage at build
 * time degrades to the static shell instead of failing the build.
 */
export async function getLatestInsights(categoryId?: string | number): Promise<LatestInsightPost[]> {
    const base = categoryId ? `categories=${categoryId}&per_page=${PER_PAGE}` : `per_page=${PER_PAGE}`;
    const query = `${base}&_fields=${LATEST_INSIGHTS_FIELDS}`;
    try {
        const posts = await getRequest<LatestInsightPost[]>(`${APIURL.BLOGS_LISTING}?${query}`);
        return Array.isArray(posts) ? posts : [];
    } catch {
        return [];
    }
}
